const BASE_URL = 'https://assets.nextorder.co';

const isURL = (str) => {
  const urlPattern = /^(https?|ftp):\/\//i;
  return urlPattern.test(str);
};

const getImage = (image) => {
  if (!image) {
    return '';
  }
  if (isURL(image)) {
    return image;
  } else {
    return `${BASE_URL}${image}`;
  }
};

export default getImage;
